import React, { createContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { fetchJobDetails } from "../controllers/job-controllers";
import { trackTotalVisits } from "../controllers/job-controllers";
import { Helmet } from "react-helmet";
import JobPage from "../sections/JobPage";

export const PageContext = createContext({});

export const PageConsumer = PageContext.Consumer;

export default function JobDetails({ company }) {
  const params = useParams();
  const job_id = params.id;
  const [jobData, setJobData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    //Save if already visited job for job tracking only once per user
    const visitedJobs = JSON.parse(localStorage.getItem("visitedJobs")) || [];

    if (!visitedJobs.includes(job_id)) {
      trackTotalVisits(job_id);
      localStorage.setItem(
        "visitedJobs",
        JSON.stringify([...visitedJobs, job_id])
      );
    }

    fetchJobDetails(job_id).then((res) => {
      if (res?.error) {
        console.log("error", res?.error);
      } else {
        if (res?.data.status !== "published") {
          navigate("/");
        }
        setJobData(res?.data);
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {company?.name
            ? `${company?.name} | ${jobData?.jobDetails?.title}`
            : jobData?.jobDetails?.title}
        </title>
        <meta
          name="description"
          content={jobData?.jobDetails?.description
            ?.replace(/<[^>]*>/g, "")
            .substring(0, 160)}
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:title" content={jobData?.jobDetails?.title} />
        <meta
          property="og:description"
          content={jobData?.jobDetails?.description
            ?.replace(/<[^>]*>/g, "")
            .substring(0, 160)}
        />
        {jobData?.jobDetails?.backgroundImage && (
          <meta
            property="og:image"
            content={jobData?.jobDetails?.backgroundImage}
          />
        )}

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={window.location.href} />
        <meta name="twitter:title" content={jobData?.jobDetails?.title} />
        <meta
          name="twitter:description"
          content={jobData?.jobDetails?.description
            ?.replace(/<[^>]*>/g, "")
            .substring(0, 160)}
        />
        {jobData?.jobDetails?.backgroundImage && (
          <meta
            name="twitter:image"
            content={jobData?.jobDetails?.backgroundImage}
          />
        )}
      </Helmet>
      {jobData && (
        <JobPage jobId={job_id} jobData={jobData} company={company} />
      )}
    </>
  );
}
